import Axios from 'axios';

// Get CSRFToken for header in API call to db
Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export default class ArticleLicensingService {
  baseUrl = '/api/v3/selfservice/article-licensing';

  async createArticleLicense(data) {
    const url = `${this.baseUrl}/`;
    const response = await Axios.post(url, data);
    return response;
  }

  async getArticleLicense(checkoutToken) {
    const url = `${this.baseUrl}?checkout_token=${checkoutToken}`;
    const response = await Axios.get(url);
    return response;
  }
}
